module.exports = __webpack_public_path__ + "static/media/icon-texts.6f8e7bf8.svg";